import { render, staticRenderFns } from "./SummaryJournal.vue?vue&type=template&id=4f3be19c&scoped=true&"
import script from "./SummaryJournal.vue?vue&type=script&lang=js&"
export * from "./SummaryJournal.vue?vue&type=script&lang=js&"
import style0 from "./SummaryJournal.vue?vue&type=style&index=0&id=4f3be19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3be19c",
  null
  
)

component.options.__file = "SummaryJournal.vue"
export default component.exports